import { Link, useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import { List, Avatar, Button, Collapse, Modal, Stack } from "@mui/material";
import styled from 'styled-components';
import { LockerPng } from "../utility/ImgNIcons";
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WidgetsIcon from '@mui/icons-material/Widgets';
import HttpsIcon from '@mui/icons-material/Https';
import CarRentalIcon from '@mui/icons-material/CarRental';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { ReactNode, useContext, useEffect, useState } from "react";
import { CustomerIcon, DashboardIcon, LockIcon, ReportsIcon, SettingIcon, VisitLogsIcon } from "../../assets/icons/SVGIcon";
import { cancelStyle } from "../modal/cancelModalStyle";
import { toast } from "react-toastify";
import { LogoutSharp } from "@mui/icons-material";
import PersonIcon from '@mui/icons-material/Person';
import Logo from "../../assets/images/nepalbanklimited.png";
import { AppContext } from "../../contexts/AppContext";
import { useCrudForm } from "../../api/useCrudForm";
import { endpoints } from "../../api/endpoints";

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: ${(props: any): string => props.small ? '10px' : '20px'};
    justify-content: between;
    padding: ${(props: any): string => props.small ? '5px 20px' : '10px'};
    width: 100%;
    text-decoration: none;
    background: ${(props: any): string => props.selected ? '#3150A133' : 'none'};
    margin-top: 5px;
    color: black;
    padding-left: ${(props: any): string => props.paddingleft ? props.paddingleft : ''};
    border-radius: 5px;
    &:hover {
        background: ${(props: any): string => props.selected ? '#D1D1D1' : (props.type === "bottom") ? '#E5E5E5' : '#FBDDDD'};
    }
    &:active {
        background: #BFBCBC;
    }
`;
const StyledMultiLink = styled(Box)`
    display: flex;
    align-items: center;
    gap: ${(props: any): string => props.small ? '10px' : '20px'};
    justify-content: between;
    padding: ${(props: any): string => props.small ? '5px 20px' : '10px'};
    width: 100%;
    text-decoration: none;
    background: ${(props: any): string => props.selected ? '#3150A133' : 'none'};
    margin-top: 5px;
    color: black;
    padding-left: ${(props: any): string => props.paddingleft ? props.paddingleft : ''};
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        background: ${(props: any): string => props.selected ? '#D1D1D1' : (props.type === "bottom") ? '#E5E5E5' : '#FBDDDD'};
    }
    &:active {
        background: #BFBCBC;
    }
`;
const StyledButton = styled(Button)`
    display: flex !important;
    align-items: center !important;
    justify-content: start !important;
    gap: 10px !important;
    padding: 5px 10px !important;
    width: 100% !important;
    margin-top: 5px !important;
    color: black !important;
    border-radius: 5px;
    &:hover { background: #E5E5E5 !important; }
`;

const UserInfo = styled(Box)`
    width: 100%;
    min-height: 180px
    padding: 5px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 0;
    color: white !important;
`;

const Sidebar = () => {
    const navigate = useNavigate();
    const [isMainBranch, setIsMainBranch] = useState(false)

    return (
        <Box sx={{
            padding: "30px 10px 5px 10px", display: "flex",
            flexDirection: "column", gap: "20px",
            minHeight: '100vh',
            justifyContent: "space-between",
            alignItems: "center",
        }}>
            <Box sx={{ display: "flex", width: "100%", flexDirection: "column", gap: "0", alignItems: "center" }}>
                <Box sx={{ minHeight: "100px" }}>
                    <Box>
                        <img onClick={() => {
                            navigate("/");
                        }} src={Logo} alt="logo" style={{ width: "100%", height: "50px", cursor: 'pointer' }} />
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                        <img src={LockerPng} alt="locker" style={{ width: "20px", height: "20px" }} />
                        <Typography variant="h6" component="h6" sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                            Locker{" "}
                            <Typography variant="h6" component="span" sx={{ fontSize: '16px', fontWeight: 'bold', color: "#3150A1" }}>System</Typography>
                        </Typography>
                    </Box>
                </Box>

                <NavigationOptions isMainBranch={isMainBranch} setIsMainBranch={setIsMainBranch} />
            </Box>

            <BottomSection setIsMainBranch={setIsMainBranch} />
        </Box>
    )
}


const NavigationOptions = ({ setTitle, isMainBranch, setIsMainBranch }: any) => {
    const [path, setPath] = useState("dashboard");
    const location = useLocation();
    const { user } = useContext(AppContext)

    useEffect(() => {
        if (location.pathname.substring(1) === "") {
            setPath("dashboard");
        } else {
            setPath(location.pathname.substring(1).split("/")[0]);
        }
    }, [location]);

    return (
        <List sx={{ width: "100%", height: "calc(100vh - 100px - 180px)", overflow: "auto", padding: "0 10px" }}>
            <CustomListItem link="dashboard" path={path} icon={<DashboardIcon selected={path === 'dashboard'} />} label="Dashboard" />
            <CustomListItem link="visit-logs" path={path} icon={<VisitLogsIcon selected={path === 'visit-logs'} />} label="Visit Logs" />
            <CustomListItem link="customers" path={path} icon={<CustomerIcon selected={path === 'customers'} />} label="Customers" />
            <MultiLevelItem label="Locker" icon={<LockIcon selected={path === 'locker'} />} path={path} link={"locker"}>
                <CustomListItem linkList={true} link="lockers" path={path} label="Lockers" icon={<HttpsIcon sx={{ color: path === 'lockers' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="locker-location" path={path} label="Locker Location" icon={<LocationOnIcon sx={{ color: path === 'locker-location' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="locker-type" path={path} label="Locker Type" icon={<WidgetsIcon sx={{ color: path === 'locker-type' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="locker-vendor" path={path} label="Locker Vendor" icon={<CarRentalIcon sx={{ color: path === 'locker-vendor' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
            </MultiLevelItem>

            <MultiLevelItem label="Reports" icon={<ReportsIcon selected={path === 'reports'} />} path={path} link={"reports"}>
                <CustomListItem linkList={true} link="reports/customersList" path={path} label="Customers Reports" icon={<AssessmentIcon sx={{ color: path === 'reports/customersList' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="reports/lockersList" path={path} label="Lockers Reports" icon={<AssessmentIcon sx={{ color: path === 'reports/lockersList' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="reports/locker-access-history" path={path} label="Locker Access History" icon={<AssessmentIcon sx={{ color: path === 'reports/locker-access-history' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
                <CustomListItem linkList={true} link="reports/locker-charges" path={path} label="Locker Charges" icon={<AssessmentIcon sx={{ color: path === 'reports/locker-charges' ? '#3150A1' : '#4F4F4F', height: '16px', width: '16px' }} />} />
            </MultiLevelItem>
            <MultiLevelItem label="Settings" icon={<SettingIcon selected={path === 'settings'} />} path={path} link={"settings"}>
                {
                    (user?.role)?.toLowerCase() === 'admin' ? <>
                        <CustomListItem link="branches" path={path} label="Branch" icon="" />
                        <CustomListItem link="users" path={path} label="Users" icon="" />
                    </> : null
                }

                {
                    isMainBranch === true ? <CustomListItem link="penaltyRate" path={path} label="Penalty Rate" icon="" /> : null
                }
            </MultiLevelItem>
        </List>
    )
}

const BottomSection = ({ setIsMainBranch }: any) => {
    const [open, setOpen] = useState(false);
    const [userName, setUserName] = useState('' as any)
    const { user, setUser, branch, setBranch } = useContext(AppContext)

    const handleClose = () => {
        setOpen(false);
    };

    const navigate = useNavigate();

    const handleOnLogout = () => {
        localStorage.removeItem('token');
        navigate("/login");
        setUser({})
        toast.success('User logged out', {
            style: {
                background: '#3150A1'
            }
        })
    }

    const { get } = useCrudForm();
    const getBranchName = ({ branchId }: any) => {
        get({
            endpoints: `${endpoints.branch.get}/${branchId}`,
            onSuccess: (data: any) => {
                setBranch(data?.data)
                setIsMainBranch(data?.data?.isMainBranch)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    useEffect(() => {
        setUserName(user?.fullName)
        getBranchName({ branchId: user?.branchId })
    }, [])

    return (
        <>
            <UserInfo>
                <StyledLink to="/" type="bottom">
                    <Avatar alt="Profile" sx={{ width: 25, height: 25, border: "2px solid rgba(0,0,0,0.1)" }} ><PersonIcon sx={{ width: '20px', height: '20px' }} /></Avatar>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%" }}>
                        <Typography component="span" sx={{ fontSize: '15px' }}>{userName}</Typography>
                        <Typography component="span" sx={{ fontSize: '12px', color: '#3150A1' }}>{(user?.role)?.toUpperCase()}</Typography>
                        <Typography component="span" sx={{ fontSize: '12px', color: '#3150A1' }}>{branch?.name}</Typography>
                    </Box>
                </StyledLink>

                <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%" }}>
                    <StyledButton onClick={() => setOpen(true)}>
                        <LogoutSharp />
                        <Typography variant="body2" component="span">Logout</Typography>
                    </StyledButton>
                </Box>
            </UserInfo>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to logout?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If yes, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <Button variant="contained" color="success" onClick={handleOnLogout}>Yes</Button>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </>
    )
}

const CustomListItem = ({ linkList, label, link, path, icon }: { linkList?: boolean, label: string, link: string, path: string, icon: ReactNode | null }) => {


    let newLink = link;
    if (link === "dashboard") {
        newLink = "";
    }
    useEffect(() => {
        if (path === link) {
            document.title = `${label} | Locker System`;
        }
    }, [path])

    return (
        <StyledLink to={`/${newLink}`} selected={path === link} paddingleft={!icon ? "10px" : ""} >
            <span style={{ width: "100%", display: 'flex', alignItems: 'center', marginLeft: linkList ? '8px' : '0px' }}>
                <span style={{ marginRight: linkList ? '5px' : '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {icon}
                </span>
                <Typography sx={{ fontSize: "12px", fontWeight: "500", color: path === link ? '#3150A1' : '#4F4F4F' }}>{label}</Typography>
            </span>
        </StyledLink>
    )
}

const MultiLevelItem = ({ label, icon, children, path, link }: { path: string, link: string, label: string, icon: any, children: any }) => {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            <StyledMultiLink onClick={handleClick}>

                <span style={{ width: "100%", display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {icon}
                    </span>

                    <Typography sx={{ fontSize: "13px", fontWeight: "500", color: path === link ? '#3150A1' : '#4F4F4F' }}>{label}</Typography>

                </span>
                {open ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}

            </StyledMultiLink>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </>
    )
}

export default Sidebar;